const deleteEquipmentModelsStr = {
  toastr: 'Deleted EquipmentModel',
  toastr1: ' successfully deleted'
};

export default deleteEquipmentModelsStr;
